"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CprUtil {
    /**
    * Insert '-' if not already there
    * @param cpr
    * @return cpr with hyphen
    */
    static format(cpr) {
        if (cpr) {
            if (cpr.length === 10) {
                return cpr.substring(0, 6) + "-" + cpr.substring(6);
            }
        }
        return cpr;
    }
    /**
     * Get patient from moduleContext
     * @param moduleContext current modules moduleContext
     */
    static getPatientCPR(moduleContext) {
        const patient = moduleContext.getPatient();
        if (!patient) {
            return null;
        }
        return patient.getCpr();
    }
    static getBirthDateFromCPR(cpr) {
        const cprDay = +cpr.slice(0, 2);
        const cprMonth = +cpr.slice(2, 4);
        const cprYear = +cpr.slice(4, 6);
        const cprSeventhDigit = +cpr[6];
        const year = CprUtil.getYear(cprYear, cprSeventhDigit);
        return new Date(year, cprMonth - 1, cprDay);
    }
    static getYear(cprYear, cprSeventhDigit) {
        if (typeof cprSeventhDigit !== "number") {
            throw new Error(`${cprSeventhDigit} is something else than a number`);
        }
        if (cprSeventhDigit < 4) {
            return 1900 + cprYear;
        }
        else if (cprSeventhDigit === 4 || cprSeventhDigit === 9) {
            if (cprYear <= 36) {
                return 2000 + cprYear;
            }
            else {
                return 1900 + cprYear;
            }
        }
        else if (cprSeventhDigit >= 5 && cprSeventhDigit <= 8) {
            if (cprYear <= 36) {
                return 2000 + cprYear;
            }
            else if (cprYear >= 58) {
                return 1800 + cprYear;
            }
        }
        throw new Error(`Not a valid CPR part: ${cprYear}`);
    }
}
exports.default = CprUtil;
//# sourceMappingURL=CprUtil.js.map